import { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import ToTopBtn from './components/ToTopBtn'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Videos from './pages/Videos'
import Seminar from './pages/Seminar'
import Maruza from './pages/Maruza'
import About from './pages/About'
import MaruzaDetails from './pages/MaruzaDetails'
import SeminarDetails from './pages/SeminarDetails'

function App() {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])
  return (
    <>
      <ToTopBtn />
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/videos' element={<Videos />} />
        <Route path='/maruza' element={<Maruza />} />
        <Route path='/seminar' element={<Seminar />} />
        <Route path='/maruza/:id' element={<MaruzaDetails />} />
        <Route path='/seminar/:id' element={<SeminarDetails />} />
        <Route path='/about' element={<About />} />
      </Routes>
      <Footer />
    </>
  )
}

export default App